const InviteActionTypes = {
  FETCH_INVITE_CODE_DATA_START: "FETCH_INVITE_CODE_DATA_START",
  FETCH_INVITE_CODE_DATA_SUCCESS: "FETCH_INVITE_CODE_DATA_SUCCESS",
  FETCH_INVITE_CODE_DATA_FAILURE: "FETCH_INVITE_CODE_DATA_FAILURE",
}

export default InviteActionTypes
